import React from 'react';
import { RevoltSwitch } from './RevoltSwitch';

const CAPABILITIES = [
  'Thinking',
  'Web Search',
  'Structured Outputs',
  'Function Calling',
  'Image Input',
  'Image Output',
  'Audio Input',
  'Video Input',
  'File Input'
];

export function ModelCapabilities({ capabilityFilters, onCapabilityChange }) {
  const handleCapabilityToggle = (capability) => {
    const currentConfig = capabilityFilters[capability] || { enabled: false, mode: 'include' };
    const newEnabled = !currentConfig.enabled;

    onCapabilityChange({
      ...capabilityFilters,
      [capability]: {
        enabled: newEnabled,
        mode: currentConfig.mode || 'include'
      }
    });
  };

  const handleModeChange = (capability, newMode) => {
    onCapabilityChange({
      ...capabilityFilters,
      [capability]: {
        ...capabilityFilters[capability],
        mode: newMode
      }
    });
  };

  return (
    <div className="model-filters-container">
      {/* Vertical Column - Each capability has button + switch horizontally aligned */}
      <div className="capabilities-row">
        {CAPABILITIES.map(capability => {
          const isEnabled = capabilityFilters[capability]?.enabled || false;
          const currentMode = capabilityFilters[capability]?.mode || 'include';

          return (
            <div key={capability} className="capability-item">
              {/* Top: Toggle Button */}
              <button
                className={`capability-toggle-btn ${isEnabled ? 'active' : ''}`}
                onClick={() => handleCapabilityToggle(capability)}
              >
                {capability}
              </button>

              {/* Bottom: Include/Exclude Switch */}
              <RevoltSwitch
                checked={currentMode === 'include'}
                onChange={(newValue) => handleModeChange(capability, newValue ? 'include' : 'exclude')}
                disabled={!isEnabled}
                className="mode-switch"
              />
            </div>
          );
        })}
      </div>

      <style>{`
        .model-filters-container {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .capabilities-row {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .capability-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 8px 0;
        }

        .capability-toggle-btn {
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.12);
          color: #f5f5f7;
          border-radius: 6px;
          padding: 6px 10px;
          font-size: 0.8rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
          text-align: center;
          flex: 1;
          min-width: 0;
        }

        .capability-toggle-btn:hover {
          border-color: rgba(255, 255, 255, 0.25);
        }

        .capability-toggle-btn.active {
          background: rgba(220, 38, 38, 0.2);
          border-color: rgba(220, 38, 38, 0.5);
          color: #fca5a5;
        }

        .capability-toggle-btn.active:hover {
          background: rgba(220, 38, 38, 0.3);
          border-color: rgba(220, 38, 38, 0.6);
        }

        .mode-switch {
          transform: scale(0.85);
          flex-shrink: 0;
        }

        /* Override RevoltSwitch disabled styling to make it more obvious */
        .mode-switch.is-disabled {
          opacity: 0.15 !important;
        }

      `}</style>
    </div>
  );
}
